import { render, staticRenderFns } from "./Rankings.vue?vue&type=template&id=6ec0f9af&scoped=true&"
import script from "./Rankings.vue?vue&type=script&lang=js&"
export * from "./Rankings.vue?vue&type=script&lang=js&"
import style0 from "./Rankings.vue?vue&type=style&index=0&id=6ec0f9af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec0f9af",
  null
  
)

export default component.exports